import { memo } from 'react';

import cn from 'classnames';

import { useWhiteboardSyncStore } from '@src/stores';

import './style.scss';

type TWhiteBoardWidth = 'full' | 'default';

const WhiteboardReadOnly = ({ width = 'default' }: { width?: TWhiteBoardWidth }) => {
  const canvasDataUrl = useWhiteboardSyncStore((s) => s.lastCanvasDataUrl);

  return (
    <div
      className={cn('whiteboard-container whiteboard-read-only', {
        [width]: width,
      })}
    >
      <div className="whiteboard-container-inner whiteboard-bg">
        <div className="whiteboard-canvas-container whiteboard-read-only-canvas">
          {canvasDataUrl ? (
            <img
              src={canvasDataUrl}
              alt="Whiteboard"
              style={{
                display: 'block',
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default memo(WhiteboardReadOnly);
